import { render, staticRenderFns } from "./socioFormDetail.vue?vue&type=template&id=b578d172"
import script from "./socioFormDetail.vue?vue&type=script&lang=js"
export * from "./socioFormDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports